import { TalentCard } from "./TalentCard"; // 재능용 카드 컴포넌트 임포트

export function GridTalent(props) {
    // 데이터가 없으면 빈 화면 반환
    if (!props.object || props.object.length === 0) {
        return <></>;
    }

    return (
        <>
            {props.object.map((item, index) => (
                <div className="col-md-3" key={item.registrationId || index}>
                    <TalentCard 
                        object={item} 
                        index={index} 
                        cityList={props.cityList} 
                        returnTo={"/talent_list"} 
                    />
                </div>
            ))}
        </>
    );
}